export default "__VITE_ASSET__DngGfqrP__"